import { ParentTypes as Parent_Type_Enum } from '@risksmart-app/domain/src/types/consts/parent-type';
import { RiskAssessmentResultControlType as Risk_Assessment_Result_Control_Type_Enum } from '@risksmart-app/domain/src/types/consts/risk-assessment-result-control-type';
import type { useGetAssessmentResultsByParentId } from 'src/hooks/queries/assessment-result/useGetAssessmentResultsByParentId';

import type { AssessmentResultFields } from './types';

type GetAssessmentResultsByParentIdData = NonNullable<
  ReturnType<typeof useGetAssessmentResultsByParentId>['data']
>;

export const getAssessmentResultTableFields = (
  data: GetAssessmentResultsByParentIdData | undefined,
  assessmentId: string
): AssessmentResultFields[] | undefined => {
  return [
    ...(data?.document_assessment_result.map((a) => ({
      ...a,
      AssessmentId: assessmentId,
      typename: Parent_Type_Enum.DocumentAssessmentResult,
    })) || []),
    ...(data?.obligation_assessment_result.map((a) => ({
      ...a,
      AssessmentId: assessmentId,
      typename: Parent_Type_Enum.ObligationAssessmentResult,
    })) || []),
    ...(data?.risk_assessment_result.map((a) => ({
      ...a,
      AssessmentId: assessmentId,
      typename: Parent_Type_Enum.RiskAssessmentResult,
    })) || []),
    ...(data?.test_result.map((a) => ({
      Id: a.Id,
      AssessmentId: assessmentId,
      Impact: 0,
      Rating: 0,
      OverallEffectiveness: a.OverallEffectiveness,
      ControlType: Risk_Assessment_Result_Control_Type_Enum.Controlled,
      TestDate: a.TestDate,
      parents: [],
      parent: a.parent!,
      files: a.files,
      ancestorContributors: [],
      typename: Parent_Type_Enum.TestResult,
    })) || []),
  ];
};
